export default Object.freeze({
	// Single User
	SingleUser: 'SingleUser',

	// Multi User
	MultiUser: 'MultiUser',
	MultiAdmin: 'MultiAdmin',

	// Corporation
	CorpUser: 'CorpUser',
	LocationAdmin: 'LocationAdmin',
	RegionAdmin: 'RegionAdmin',
	CorpAdmin: 'CorpAdmin',
});
